import Mock from 'mockjs'

function fakeSuccess(data) {
    const json = { code: 200, success: true, msg: '操作成功' };
    json.data = data;
    return json;
}
export default ({ mock }) => {
    if (!mock) return;
    //监控台-呼叫实时情况-接口
    let callStatusJson = {
        todayCall:0,
        callPercentageComplete:"100 %",
        averageCompletionTime:"3 天",
        planPercentageComplete:"0 天/单"
    }
    let callVolumeTrendJson={
        xAxisData: [
            '一月',
            '二月',
            '三月',
            '四月',
            '五月',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月'
        ],
        seriesList: [
            {
                name: '完成数',
                data:[5, 1, 1, 3, 5, 3, 1, 0, 1, 4, 2, 0, 2, 3],
            },
            {
                name: '新增数',
                data: [6, 3, 2, 5, 7, 4, 2, 0, 1, 4, 3, 0, 2, 4],
            }   
        ]
    }
    //监控台-往年预青数据-接口
    let formerYearsJson ={
        legendData:["2017年", "2018年", "2019年"],
        seriesList:[
            {
                name:"2017年",
                data:[48, 208, 1719]
            },
            {
                name:"2018年",
                data:[92, 449, 1782]
            },
            {
                name:"2019年",
                data:[91, 359, 1818]
            }
        ]
    }
    //监控台-历年预青数据-接口
    let overYearsJson={
        legendData:["2020年", "2021年"],
        seriesList:[
            {
                name:"2020年",
                data:[36, 186, 1154],
            },
            {
                name:"2021年",
                data:[58, 343, 1535],
            }
        ]
    }
    //监控台-青少年信息-接口
    let adolescentJson = {
        tattooIndex:0,//有纹身数量
        aggressiveBehaviorIndex:0,//曾有过过激行为
        amusementIndex:0,//常出没于娱乐场所
        irregularRoutine:0,//作息时间不规律
        stayOutIndex:0,//有夜不归宿行为
        watchObsceneVideoIndex:0,//有观看淫秽行为
        fightBehaviorIndex:0,//有打架行为
        playVideoGamesIndex:0,//喜欢网络游戏
        masturbationIndex:0,//有手淫行为
    }
    //监控台-救助数据-接口
    let salvageJson  = {
        salvationIndex:0,//救助件总数
        salvationUnderwayIndex:0,//救助在办件
        salvationFulfillIndex:0,//救助完成件
        salvationCapitalSum:0,//救助资金总额
        salvationHeadcount:0,//救助总人数
        entitySalvationIndex:0//实物救助的人数
    }
    //监控台-呼叫类型占比-接口
    let breatheTyleJson  = {
        breatheTyleSum:100,//占比总数
        psychologicalAssistance:20,//心理援助
        educationSupporting:15,//教育支持
        communityCorrection:15,//社区矫正
        tutelageIndex:25,//督促监护令
        socialAssistance:30,//社会救助
        MinimumProtection:15//最低保障
    }

    //监控台-呼叫实时情况-接口
    Mock.mock(/\/api\/blade-stat\/console\/todayCallData/, 'get', fakeSuccess(callStatusJson));
    //监控台-呼叫量趋势-接口
    Mock.mock(/\/api\/blade-stat\/console\/callVolumeTrendData/, 'get', fakeSuccess(callVolumeTrendJson));
    //监控台-往年预青数据-接口
    Mock.mock(/\/api\/blade-stat\/console\/formerYearsYouthData/, 'get', fakeSuccess(formerYearsJson));
    //监控台-历年预青数据-接口
    Mock.mock(/\/api\/blade-stat\/console\/overYearsYouthData/, 'get', fakeSuccess(overYearsJson));
    //监控台-青少年信息-接口
    Mock.mock(/\/api\/blade-stat\/console\/adolescentData/, 'get', fakeSuccess(adolescentJson));
    //监控台-救助数据-接口
    Mock.mock(/\/api\/blade-stat\/console\/salvageData/, 'get', fakeSuccess(salvageJson));
    //监控台-呼叫类型占比-接口
    Mock.mock(/\/api\/blade-stat\/console\/breatheTyleData/, 'get', fakeSuccess(breatheTyleJson));
    

}
